var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"email-recipient-nav"},[(_vm.emailId)?_c('router-link',{staticClass:"btn btn-block btn-primary",attrs:{"tag":"button","to":{
      name: 'create_email_recipient',
      params: {
        emailId: _vm.emailId,
        newsletterId: _vm.newsletterId
      }
    }}},[_vm._v("\n    Add Recipient\n  ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-danger",on:{"click":function($event){return _vm.deleteByStatus('queued')}}},[_vm._v("\n    Delete Queued Recipients\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47f350b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailRecipientsActions.vue
// module id = 1181
// module chunks = 1